/**
 * @package   freecaster/luna/player
 * @author    François Arki <francois.arki@freecaster.com>
 * @copyright Freecaster 2020
 */

import {PlayerProperty} from '../PlayerProperty'

class StartProperty extends PlayerProperty {
  /**
   *
   * @param player
   * @param {ServerEvent} value
   * @return {Promise<void>}
   */
  async handle(player, value) {
    player.config.start = value.target.attributes
    player.fc_features.get('ChaptersFlowPlayerFeature').videoStart = value.target.attributes
  }

  getName () {
    return 'start'
  }
}

export const startProperty = new StartProperty()
